export default [
  {
    title: '首页',
    path: '/',
  },
  {
    name: 'software',
    title: '系列软件',
    children: [
      {
        name: 'inventory-management-system',
        title: '库存管理系统',
        path: '/inventory',
      },
      {
        name: 'mobile-order',
        title: '商购点货app',
        path: '/mobile',
      },
      {
        name: 'order-software-staff',
        title: '推销员版',
        path: '/staff',
      },
    ],
  },
  {
    title: '使用教程',
    path: '/content/1',
  },
  {
    title: '关于我们',
    path: '/content/4',
  },
];
